import React from 'react';
import PropTypes from 'prop-types';
import { Loc } from 'redux-react-i18n';
import { Link } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import Icon from 'components/mediabay-ui/components/Icon';
import IconButton from 'components/mediabay-ui/components/IconButton';
import {
  StyledContainer,
  InfoContainer,
  VideoTitle,
  StyledList,
  VideoDescription,
  VideoMeta,
  VideoNameTitle,
  PlayerContainer,
  StyledCloseButton,
  StyledPlayButton,
} from './StyledDetails';

class MediaDetails extends React.Component {
  static propTypes = {
    currentLanguage: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    mediaDetailsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.number,
        PropTypes.array,
        PropTypes.object,
      ])),
    }),
    closeDetailsHandler: PropTypes.func.isRequired,
    playRoute: PropTypes.string.isRequired,
  }

  static defaultProps = {
    mediaDetailsData: {
      status: null,
      data: null,
    },
  }

  trimHtmlTags() {
    const { mediaDetailsData, currentLanguage } = this.props;
    const content = document.createElement('div');

    if (Object.keys(mediaDetailsData.data).length) {
      content.innerHTML = (
        mediaDetailsData.data.description[currentLanguage] || mediaDetailsData.data.description['ru']
      );
    }

    return content.textContent || content.innerText || '';
  }

  render() {
    const {
      currentLanguage,
      mediaDetailsData,
      isVisible,
      closeDetailsHandler,
      playRoute,
    } = this.props;


    return (
      <StyledContainer
        isVisible={isVisible}
        ref={(node) => { this.mediaDetailsRef = node; }}
        {...this.props}
      >
        <InfoContainer>
          {mediaDetailsData.status !== null && mediaDetailsData.status === 200 ? (
            <div>
              <div>
                <VideoTitle>
                  {mediaDetailsData.data.title[currentLanguage]}
                </VideoTitle>
                <StyledList>
                  <li style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                    <span>
                      {new Date(mediaDetailsData.data.dateCreated).getFullYear()}
                    </span>
                  </li>
                  {
                    mediaDetailsData.data.rating.imdb && (
                      <li style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                        <Icon icon="imdb" width={28} height={28} style={{ marginRight: 3 }} />
                        <span>
                          {
                            Number.parseFloat(mediaDetailsData.data.rating.imdb).toFixed(1)
                          }
                        </span>
                      </li>
                    )
                  }
                  {
                    !!mediaDetailsData.data.rating.kinopoisk && (
                      <li style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                        <Icon icon="kinopoisk" width={20} height={20} style={{ marginRight: 3 }} />
                        <span>
                          {
                            Number.parseFloat(mediaDetailsData.data.rating.kinopoisk).toFixed(1)
                          }
                        </span>
                      </li>
                    )
                  }
                </StyledList>
                <VideoDescription>
                  {
                    <Dotdotdot clamp={4} useNativeClamp>
                      <p style={{ margin: 0 }}>
                        {this.trimHtmlTags()}
                      </p>
                    </Dotdotdot>
                  }
                </VideoDescription>
              </div>
              <VideoMeta>
                {
                  mediaDetailsData.data.actors.map(actor => (
                    <Link to={`/actor/${actor.id}`} key={actor.id} style={{ width: 70, marginRight: 20 }}>
                      <img
                        src={actor.photo.replace('.jpg', '.70.jpg')}
                        alt={actor.name[currentLanguage] || actor.name['ru']}
                        width={70}
                        height={70}
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      />

                      <VideoNameTitle>
                        {actor.name[currentLanguage] || actor.name['ru']}
                      </VideoNameTitle>
                    </Link>
                  ))
                }
              </VideoMeta>
            </div>
          ) : (
            <VideoTitle>
              <Loc locKey="noMediaData" />
            </VideoTitle>
          )}
        </InfoContainer>
        {
          mediaDetailsData.status !== null && mediaDetailsData.status === 200 ? (
            <PlayerContainer
              background={
                mediaDetailsData.data.screens.length && mediaDetailsData.data.screens[0].path
              }
            >
              <StyledCloseButton>
                <Icon icon="close" onClick={closeDetailsHandler} />
              </StyledCloseButton>
              <StyledPlayButton to={{ pathname: `/${playRoute}/${mediaDetailsData.data.id}`, search: 'play' }}>
                <IconButton icon="play" width={30} height={30} style={{}} />
              </StyledPlayButton>
            </PlayerContainer>
          ) : null
        }
      </StyledContainer>
    );
  }
}

export default MediaDetails;
